<div class="language-selector">
  <div class="language-selector__control">
    <select class="language-selector__select" [id]="selectId" [ngModel]="currentLanguage"
      [attr.aria-label]="ariaLabelTranslationKey | t" (ngModelChange)="onSelect($event)">
      @for (language of languages; track language.code) {
      <option [value]="language.code">{{ language.flag }} {{ language.labelKey | t }}</option>
      }
    </select>
  </div>
</div>
